import React from 'react';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import { useLinesContext } from '../../contexts/Lines';
import {
  finishWithRequest,
  rejectApplication,
  rejectRequestChange,
} from '../API';
import messages from '../../messages';
import cloneDeep from 'lodash.clonedeep';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PlanWrapper from './PlanWrapper';

export default function PlansTableBody({
  plans,
  setPlans,
  numColumns,
  openPlanDiscovery,
  deletePlan,
  setLoading,
}) {
  const snackbar = useSnackbarContext();
  const { setLines } = useLinesContext();
  const { trackEvent } = useEventTrackerContext();

  function expandRow(id: string) {
    const plansCopy = cloneDeep(plans);
    const updatedPlans = plansCopy.map((plan) => {
      if (plan.id === id) {
        plan['expanded'] = !plan['expanded'];
      }
      return plan;
    });
    setPlans(updatedPlans);
  }

  function updatePlanName(id: string, newName: string) {
    const updatedPlans = plans.map((plan) => {
      if (plan.id === id) {
        plan.displayName = newName;
      }
      return plan;
    });
    setPlans(updatedPlans);
  }

  async function rejectEditedPlan(plan: any, reason, extraText) {
    setLoading(true);
    setLines(null);
    try {
      if (plan.opcId) {
        const changeRequestId = plan.opcId;
        await rejectRequestChange(changeRequestId, reason, extraText);
        await finishWithRequest(changeRequestId);
      } else {
        await rejectApplication(plan.id, reason, extraText);
      }
      const plansCopy = cloneDeep(plans);
      const updatedPlans = plansCopy.filter((p) => p.id !== plan.id);
      setPlans(updatedPlans);
      snackbar.show(messages.plans.rejectPlanChanges, 'success');
      trackEvent({ event: 'plan_rejected', plan });
    } catch (error) {
      snackbar.show(messages.plans.errors.acceptPlanChanges, 'error');
    }
    setLoading(false);
  }

  return (
    <TableBody>
      {plans.length === 0 && (
        <TableRow>
          <TableCell colSpan={numColumns} align="center">
            <h2>No plans matching filter.</h2>
          </TableCell>
        </TableRow>
      )}
      {plans.length > 0 && (
        <React.Fragment>
          {plans.map((plan) => (
            <PlanWrapper
              key={plan.id}
              plan={plan}
              updatePlanName={updatePlanName}
              expandRow={expandRow}
              numColumns={numColumns}
              openPlanDiscovery={openPlanDiscovery}
              deletePlan={deletePlan}
              rejectEditedPlan={rejectEditedPlan}
              plans={plans}
              setPlans={setPlans}
              setLoading={setLoading}
            />
          ))}
        </React.Fragment>
      )}
    </TableBody>
  );
}
